import { render, staticRenderFns } from "./draftMove.vue?vue&type=template&id=703b0e9a&scoped=true"
import script from "./draftMove.vue?vue&type=script&lang=js"
export * from "./draftMove.vue?vue&type=script&lang=js"
import style0 from "./draftMove.vue?vue&type=style&index=0&id=703b0e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b0e9a",
  null
  
)

export default component.exports